
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Table from "../../../Utils/Table/Table";
import ApiService from "../../../Services/user/service";
import Swal from "sweetalert2";
import exportToExcel from "../../../Utils/Exportfile";
const Order = () => {
  const [orders, setOrders] = useState([]);
  const [activeTab, setActiveTab] = useState("closed");
  const user_id = localStorage.getItem("user_id");
  const currency = localStorage.getItem("currentCurrency");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editPrice, setEditPrice] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewOrder, setViewOrder] = useState(null);
  const location = useLocation();
  const isFromWatchlist = location.state?.watchlist || false;

  const getExcelHeaders = (activeTab) => {
    if (activeTab === "open") {
      return [
        { label: "Symbol", key: "symbol" },
        { label: "Type", key: "type" },
        { label: "Quantity", key: "qty" },
        { label: "Option Type", key: "selectedOption" },
        { label: "LTP", key: "ltp" },
        { label: "Price", key: "price" },
        { label: "Amount", key: "totalamount" },
        { label: "Lot", key: "lot" },
        { label: "Date", key: "createdAt" },
        { label: "Status", key: "status" },
      ];
    }

    // CLOSED
    return [
      { label: "Symbol", key: "symbol" },
      { label: "Type", key: "type" },
      { label: "Quantity", key: "qty" },
      { label: "Price", key: "price" },
      { label: "Amount", key: "totalamount" },
      { label: "Lot", key: "lot" },
      { label: "Date", key: "createdAt" },
      { label: "Status", key: "status" },
    ];
  };


  useEffect(() => {
    if (isFromWatchlist) {
      setActiveTab("open");
    }
  }, [isFromWatchlist]);


  const fetchOrders = async () => {
    try {
      let res;

      const payload = {
        userid: user_id,
      };

      // Add date filters if selected
      if (fromDate) payload.fromDate = fromDate;
      if (toDate) payload.toDate = toDate;

      if (currency === "0") {
        res = await ApiService.getOrderBook(payload);
      } else {
        res = await ApiService.getOrderBookInr(payload);
      }

      setOrders(res?.data?.data || []);
    } catch (err) {
      setOrders([]);
    }
  };


  useEffect(() => {
    if (user_id) fetchOrders();
  }, [user_id, currency, fromDate, toDate]);


  const filteredOrders = orders.filter((item) => {
    const status = item.status?.toLowerCase();

    if (activeTab === "open") {
      return status === "pending";
    }

    return status === "completed";
  });


  const handleEdit = (order) => {
    setSelectedOrder(order);
    setEditPrice(order.price);
    setEditModalOpen(true);
  };


  // const handleDelete = async (id) => {
  //   const data = {
  //     userid: user_id,
  //     _id: id,
  //   };

  //   await ApiService.deletePendingOrder(data);
  //   await fetchOrders();
  // };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirm.isConfirmed) return;

    try {
      const data = { userid: user_id, _id: id };

      if (currency === "0") {
        await ApiService.deletePendingOrder(data);
      } else {
        await ApiService.deletePendingOrderInr(data);
      }
      // await ApiService.deletePendingOrder(data);

      Swal.fire("Deleted!", "Order deleted successfully", "success");

      await fetchOrders();
    } catch (error) {
      Swal.fire("Error", "Something went wrong while deleting!", "error");
    }
  };


  const closedcolumns = [
    { Header: "Symbol", accessor: "symbol" },
    {
      Header: "Type",
      accessor: "type",
      Cell: ({ cell }) => {
        const isBuy = cell.value?.toLowerCase() === "buy";
        return (
          <span className={isBuy ? "text-success fw-bold" : "text-danger fw-bold"}>
            <span className="type-icon">
              {isBuy ? "📈" : "📉"}
            </span>
            {cell.value ? cell.value.toUpperCase() : ""}
          </span>
        );
      },
    },
    { Header: "Qty", accessor: "qty" },
    {
      Header: "Price",
      accessor: "price",
      Cell: ({ cell }) => cell.value ? `${currency === "0" ? "$" : "₹"} ${(+cell.value).toFixed(2)}` : "-",
    },
    {
      Header: "Amount",
      accessor: "totalamount",
      Cell: ({ cell }) => Number(cell.value)?.toFixed(2),
    },
    {
      Header: "Lot",
      accessor: "lot",
      cell: ({ cell }) => Number(cell.value)?.toFixed(2),
    },
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => new Date(cell.value).toLocaleString(),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.value?.toLowerCase();

        return (
          <span
            className={`status-badge ${status === "completed" ? "status-completed" : "status-pending"
              }`}
          >
            <span className="status-icon">
              {status === "completed" ? "✔️" : "⏳"}
            </span>
            {cell.value}
          </span>
        );
      }
    },
    {
      Header: "Action",
      accessor: "view",
      Cell: ({ cell }) => {
        const rowData = cell.row.original || cell.row;
        return (
          <button
            className="btn btn-sm btn-info w-100 text-white fw-bold"
            onClick={() => {
              setViewOrder(rowData);
              setViewModalOpen(true);
            }}
          >
            👁️ View
          </button>
        );
      },
    }

  ];

  const openColumns = [
    { Header: "Symbol", accessor: "symbol" },

    {
      Header: "Type",
      accessor: "type",
      Cell: ({ cell }) => {
        const isBuy = cell.value?.toLowerCase() === "buy";
        return (
          <span className={isBuy ? "text-success fw-bold" : "text-danger fw-bold"}>
            <span className="type-icon">
              {isBuy ? "📈" : "📉"}
            </span>
            {cell.value ? cell.value.toUpperCase() : ""}
          </span>
        );
      },
    },


    { Header: "Qty", accessor: "qty" },
    {
      Header: "Option Type",
      accessor: "selectedOption",
    },

    {
      Header: "LTP",
      accessor: "ltp",
      Cell: ({ cell }) => {
        const value = cell.value;

        return value === null || value === undefined || value === ""
          ? "–"
          : Number(value).toFixed(2);
      },
    },

    {
      Header: "Price",
      accessor: "price",
      Cell: ({ cell }) => cell.value ? `${currency === "0" ? "$" : "₹"} ${(+cell.value).toFixed(2)}` : "-",
    },

    {
      Header: "Amount",
      accessor: "totalamount",
      Cell: ({ cell }) => Number(cell.value)?.toFixed(2),
    },
    {
      Header: "Lot",
      accessor: "lot",
      cell: ({ cell }) => Number(cell.value)?.toFixed(2),
    },

    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => new Date(cell.value).toLocaleString(),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.value?.toLowerCase();

        return (
          <span
            className={`status-badge ${status === "completed" ? "status-completed" : "status-pending"
              }`}
          >
            <span className="status-icon">
              {status === "completed" ? "✔️" : "⏳"}
            </span>
            {cell.value}
          </span>
        );
      }
    },

    {
      Header: "Modify",
      accessor: "modify",
      Cell: ({ cell }) => {
        const rowData = cell.row;

        return (
          <button
            className="btn btn-sm btn-warning w-100"
            onClick={() => handleEdit(rowData)}
          >
            ✏️ Modify
          </button>
        );
      },
    },

    {
      Header: "Delete",
      accessor: "delete",
      Cell: ({ cell }) => {
        const rowData = cell.row.original || cell.row;

        return (
          <button
            className="btn btn-sm btn-danger w-100"
            onClick={() => handleDelete(rowData._id)}
          >
            🗑 Delete
          </button>
        );
      },
    },
    {
      Header: "Action",
      accessor: "view",
      Cell: ({ cell }) => {
        const rowData = cell.row.original || cell.row;
        return (
          <button
            className="btn btn-sm btn-info w-100 text-white fw-bold"
            onClick={() => {
              setViewOrder(rowData);
              setViewModalOpen(true);
            }}
          >
            👁️ View
          </button>
        );
      },
    }
  ];

  const handleSavePrice = async () => {
    if (!selectedOrder) return;

    const confirm = await Swal.fire({
      title: "Update Price?",
      text: "Are you sure you want to modify this price?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
    });

    if (!confirm.isConfirmed) return;

    try {
      const data = {
        userid: selectedOrder.userid,
        _id: selectedOrder._id,
        price: Number(editPrice),
      };

      if (currency === "0") {
        // USD
        await ApiService.updatePendingOrderUsd(data);
      } else {
        // INR
        await ApiService.updatePendingOrder(data);
      }

      Swal.fire("Updated!", "Price updated successfully", "success");

      await fetchOrders();
      setEditModalOpen(false);

    } catch (err) {
      Swal.fire("Error", "Something went wrong while updating price", "error");
    }
  };



  function hanleClearFilters() {
    setFromDate("");
    setToDate("");
  }

  return (
    <div className="container-fluid">

      {/* ---------- Toggle (Open | Closed) ---------- */}

      <div className="card transaction-table">
        <div className="card-header d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 px-2 py-2">
          <div className="card-title m-0" style={{ fontSize: "16px", whiteSpace: "nowrap" }}>
            Order Book ({currency === "0" ? "USD" : "INR"})
          </div>
          <div className="wallet-tabs w-100 d-flex justify-content-sm-end justify-content-between">
            <div className="btn-group w-100 w-sm-auto" role="group" style={{ gap: "2px" }}>

              <button
                type="button"
                className={`btn ${activeTab === "closed" ? "btn-primary" : "btn-outline-primary"
                  }`}
                onClick={() => setActiveTab("closed")}
              >
                Closed Orders
              </button>

              <button
                type="button"
                className={`btn ${activeTab === "open" ? "btn-primary" : "btn-outline-primary"
                  }`}
                onClick={() => setActiveTab("open")}
              >
                Open Orders
              </button>

            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row g-2 mb-3 align-items-end">
            {/* From Date */}
            <div className="col-6 col-md-2">
              <label className="fw-bold mb-1" style={{ fontSize: "11px" }}>📅 From Date</label>
              <input
                type="date"
                className="form-control form-control-sm"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            {/* To Date */}
            <div className="col-6 col-md-2">
              <label className="fw-bold mb-1" style={{ fontSize: "11px" }}>📅 To Date</label>
              <input
                type="date"
                className="form-control form-control-sm"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            {/* Apply Button */}
            <div className="col-6 col-md-2">
              <button
                className="btn btn-primary btn-sm w-100"
                onClick={hanleClearFilters}
              >
                Clear
              </button>
            </div>
            <div className="col-6 col-md-2 ms-md-auto">
              <button
                className="btn btn-success btn-sm w-100"
                onClick={() =>
                  exportToExcel(
                    filteredOrders,
                    getExcelHeaders(activeTab),
                    activeTab === "open" ? "Open_Orders" : "Closed_Orders"
                  )
                }

              >
                Export Excel
              </button>
            </div>
          </div>
          <Table
            data={filteredOrders}
            columns={activeTab === "open" ? openColumns : closedcolumns}
          />
        </div>
      </div>



      {editModalOpen && (

        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0, 0, 0, 0.55)",
            backdropFilter: "blur(6px)",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: "430px", width: "95%" }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: "18px",
                overflow: "hidden",
                boxShadow: "0 8px 35px rgba(0,0,0,0.18)",
                background: "white",
              }}
            >

              {/* HEADER */}
              <div
                className="modal-header"
                style={{
                  background: "#f7faff",
                  borderBottom: "1px solid #e6e6e6",
                  padding: "14px 18px",
                }}
              >
                <h5
                  className="modal-title"
                  style={{
                    fontWeight: 700,
                    fontSize: "18px",
                  }}
                >
                  Modify Price ?
                </h5>
                <button type="button" className="btn-close" onClick={() => setEditModalOpen(false)} />
              </div>

              {/* BODY */}
              <div className="modal-body" style={{ padding: "18px" }}>

                {selectedOrder && (
                  <>
                    {/* INFO CARD */}
                    <div
                      style={{
                        background: "#f5f7fb",
                        padding: "14px",
                        borderRadius: "12px",
                        border: "1px solid #ececec",
                        marginBottom: "18px",
                      }}
                    >
                      <div className="d-flex justify-content-between mb-2">
                        <span><strong>Symbol:</strong> {selectedOrder.symbol}</span>
                        <span
                          style={{
                            fontWeight: 700,
                            color: selectedOrder.type === "sell" ? "#E53935" : "#2E7D32",
                          }}
                        >
                          {selectedOrder.type.toUpperCase()}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between mb-2">
                        <span><strong>Qty:</strong> {selectedOrder.qty}</span>
                        <span><strong>Lot:</strong> {selectedOrder.lot}</span>
                      </div>

                      <div className="d-flex justify-content-between mb-1">
                        <span><strong>LTP:</strong></span>
                        <span style={{ fontWeight: 700, color: "green" }}>
                          {selectedOrder.ltp ?? "—"}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span><strong>Current Price:</strong></span>
                        <span style={{ fontWeight: 700 }}>{currency === "0" ? "$" : "₹"}{selectedOrder.price}</span>
                      </div>
                    </div>

                    {/* UPDATE PRICE */}
                    <label className="fw-bold mb-2" style={{ fontSize: "14px" }}>
                      New Price
                    </label>
                    <div className="input-group">
                      <span
                        className="input-group-text"
                        style={{
                          background: "#e9ffe9",
                          color: "green",
                          fontWeight: 700,
                        }}
                      >
                        {currency === "0" ? "$" : "₹"}
                      </span>
                      <input
                        type="number"
                        className="form-control"
                        value={editPrice}
                        onChange={(e) => setEditPrice(e.target.value)}
                        style={{
                          fontWeight: "700",
                          padding: "10px",
                        }}
                      />
                    </div>
                  </>
                )}
              </div>


              <div
                className="modal-footer"
                style={{
                  background: "#f8f8f8",
                  borderTop: "1px solid #e6e6e6",
                  padding: "6px 8px",
                }}
              >
                <button
                  className="btn"
                  style={{
                    background: "#ffe5e5",
                    color: "#c62828",
                    fontWeight: "600",
                    padding: "8px 22px",
                  }}
                  onClick={() => setEditModalOpen(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn"
                  style={{
                    background: "#d9ffe0",
                    color: "green",
                    fontWeight: "700",
                    padding: "8px 22px",
                  }}
                  onClick={() => {
                    setEditModalOpen(false);
                    handleSavePrice();
                  }}
                >
                  Confirm
                </button>
              </div>

            </div>
          </div>
        </div>
      )}




      {/* VIEW MODAL */}
      {viewModalOpen && viewOrder && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0, 0, 0, 0.55)",
            backdropFilter: "blur(6px)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "400px" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none" }}>
              <div className="modal-header" style={{ background: "#f8f9fa", borderBottom: "1px solid #dee2e6", borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>
                <h5 className="modal-title fw-bold">Order Details</h5>
                <button type="button" className="btn-close" onClick={() => setViewModalOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted fw-bold">Symbol</span>
                    <span className="fw-bold">{viewOrder.symbol}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted fw-bold">Type</span>
                    <span className="fw-bold text-uppercase" style={{ color: viewOrder.type === 'buy' || viewOrder.type === 'BUY' ? 'green' : 'red' }}>{viewOrder.type}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted fw-bold">Exchange Segment</span>
                    <span className="fw-bold">{viewOrder.exch_seg || "-"}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted fw-bold">Lot Size</span>
                    <span className="fw-bold">{viewOrder.lotsize || "-"}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted fw-bold">Quantity</span>
                    <span className="fw-bold">{viewOrder.qty || "-"}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted fw-bold">Converted</span>
                    <span className="fw-bold text-uppercase">{viewOrder.Converted || viewOrder.margin_type || viewOrder.With_Margin}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted fw-bold">Date & Time (IST)</span>
                    <span className="fw-bold">
                      {viewOrder.createdAt 
                        ? new Date(viewOrder.createdAt).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', hour12: true }) 
                        : "-"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted fw-bold">Exit Type</span>
                    <span className="fw-bold text-uppercase">{viewOrder.Exittype || viewOrder.Exit_Type || "Null"}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Order;
